module.exports = __webpack_public_path__ + "static/media/dso-analysis.685d374a.svg";